export enum ClientPreferencesE {
  ALLOW_MARKETING_EMAIL_CONTACT = 'ALLOW_MARKETING_EMAIL_CONTACT',
  ALLOW_MARKETING_PHONE_CONTACT = 'ALLOW_MARKETING_PHONE_CONTACT',
}

export enum clientPreferencesCheckboxesE {
  allowCateringEmailMessages = 'allowCateringEmailMessages',
  allowCateringSMSMessages = 'allowCateringSMSMessages',
}
